import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import hi from "./locales/hi.json";
import gu from "./locales/gu.json";
import listPagesEn from "./listPages.en.json";
import listPagesHi from "./listPages.hi.json";
import listPagesGu from "./listPages.gu.json";
import marketingPagesEn from "./marketingPages.en.json";
import marketingPagesHi from "./marketingPages.hi.json";
import marketingPagesGu from "./marketingPages.gu.json";

const enMerged = {
  ...en,
  listPages: { ...en.listPages, ...listPagesEn },
  marketing: { ...en.marketing, ...marketingPagesEn },
};
const hiMerged = {
  ...hi,
  listPages: { ...hi.listPages, ...listPagesHi },
  marketing: { ...hi.marketing, ...marketingPagesHi },
};
const guMerged = {
  ...gu,
  listPages: { ...gu.listPages, ...listPagesGu },
  marketing: { ...gu.marketing, ...marketingPagesGu },
};

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "gu", label: "Gujarati", native: "ગુજરાતી" },
];

const saved = (() => {
  try {
    return localStorage.getItem("erp_language");
  } catch {
    return null;
  }
})();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enMerged },
    hi: { translation: hiMerged },
    gu: { translation: guMerged },
  },
  lng: saved || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem("erp_language", lng);
  } catch {
    /* ignore */
  }
  document.documentElement.lang = lng;
});

export default i18n;
